import * as Sentry from "@sentry/react-native";

const sentryEnvironment = process.env.SENTRY_ENVIRONMENT?.trim() ?? "development";
const sentryRelease = process.env.SENTRY_RELEASE?.trim();

const enabled = sentryEnvironment === "production" || sentryEnvironment === "stage";

export const routingInstrumentation = Sentry.reactNavigationIntegration();

Sentry.init({
  dsn: "https://b41d994af645ceb351dc6ae3942f4968@o4507644674834432.ingest.us.sentry.io/4507914951917568",
  enableTimeToInitialDisplay: true,
  integrations: [routingInstrumentation],
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  environment: sentryEnvironment,
  enabled,
  release: sentryRelease,
  ignoreErrors: [
    "User not found",
    "Tenant not found",
    "Failed to refresh token",
    "Email or password is incorrect",
    "Response not successful: Received status code 400",
  ],
});

export default Sentry;
